import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import PropertiesController from '../../../../controllers/PropertiesController';
import PeriodicInvoiceHistoryRow from './PeriodicInvoiceHistoryRow';
import { ApplicationContext } from '../../../../ApplicationContext';
import GetPeriodicInvoiceConceptCommand from '../../../../commands/periodicInvoiceConcepts/GetPeriodicInvoiceConceptCommand';
import PeriodicInvoiceConceptModel from '../../../../stores/models/PeriodicInvoiceConceptModel';

/**
 *
 */
class PeriodicInvoiceHistory extends React.Component {
	/**
	 *
	 * @param props
	 */
	// eslint-disable-next-line no-useless-constructor
	constructor(props) {
		super(props);
	}

	/**
	 *
	 */
	componentDidMount() {
		// Retrieve history and force render when retrieved
		const company = this.context.applicationStore.getSelectedCompany();
		if (company) {
			const command = new GetPeriodicInvoiceConceptCommand(
				this.props.periodicInvoiceConceptModel,
				company
			);
			command.execute(() => {
				this.forceUpdate();
			});
		}
	}

	/**
	 *
	 * @return {*}
	 */
	render() {
		// Always hide on demo account
		if (PropertiesController.getProperty(PropertiesController.FEATURE_DEMO)) {
			return null;
		}

		const rows = this.props.periodicInvoiceConceptModel.history.map((historyData, index) => {
			return (
				<PeriodicInvoiceHistoryRow
					key={`inv-his-${index}`}
					description={historyData.description}
					date={historyData.date}
				/>
			);
		});

		return (
			<div className="periodic-invoice-history panel grid col--12 box-shadow border border--dark">
				<div className="periodic-invoice-history__header padding grid grid--spread">
					<h2>
						<FormattedMessage id="invoice.history.title" />
					</h2>
				</div>
				<div className="periodic-invoice-history__rows grid">{rows}</div>
			</div>
		);
	}
}

PeriodicInvoiceHistory.contextType = ApplicationContext;

PeriodicInvoiceHistory.propTypes = {
	periodicInvoiceConceptModel: PropTypes.instanceOf(PeriodicInvoiceConceptModel),
	// eslint-disable-next-line react/no-unused-prop-types
	intl: PropTypes.object
};

export default injectIntl(PeriodicInvoiceHistory);
